import { Modal } from 'antd';

export const EXTEND_CONFLICT_MEETING_NO_QUERY = 'extendConflictMeetingNo';
export const REBOOK_MEETING_NO_QUERY = 'rebookMeetingNo';

const EXTEND_MEETING_CONFLICT_ERROR_CODE = 400403052;
const EXTEND_MEETING_CONFLICT_ERROR_MESSAGE = 'Room has conflicting bookings during the extended period';
const EXTEND_MEETING_NOT_ONGOING_ERROR_CODE = 400403053;
const EXTEND_MEETING_NOT_ONGOING_ERROR_MESSAGE = '非进行中会议不可延长';
const EXTEND_MEETING_ERROR_MESSAGES = {
  [EXTEND_MEETING_NOT_ONGOING_ERROR_CODE]: EXTEND_MEETING_NOT_ONGOING_ERROR_MESSAGE,
};
const REBOOK_MEETING_ERROR_CODES = [4001000, EXTEND_MEETING_CONFLICT_ERROR_CODE];
const REBOOK_MEETING_ERROR_MESSAGES = [
  'newEndTime must be after current endTime',
  EXTEND_MEETING_CONFLICT_ERROR_MESSAGE,
];

const getErrorData = (error: any) => {
  return error?.response?.data || error?.data || error;
};

export const getExtendMeetingErrorMessage = (error: any): string => {
  const data = getErrorData(error);
  return EXTEND_MEETING_ERROR_MESSAGES[data?.code] || data?.message || '延长会议失败';
};

export const isExtendMeetingRebookError = (error: any): boolean => {
  const data = getErrorData(error);
  if (data?.message) {
    return REBOOK_MEETING_ERROR_MESSAGES.some((message) => data.message.includes(message));
  }
  return REBOOK_MEETING_ERROR_CODES.includes(data?.code);
};

export const isExtendMeetingConflictError = (error: any): boolean => {
  const data = getErrorData(error);
  if (data?.code === EXTEND_MEETING_CONFLICT_ERROR_CODE) {
    return true;
  }
  return data?.message?.includes(EXTEND_MEETING_CONFLICT_ERROR_MESSAGE) || false;
};

export const showExtendMeetingRebookConfirm = (onOk: () => void) => {
  setTimeout(() => {
    Modal.confirm({
      title: '延长会议失败',
      icon: '',
      content: '是否重新预约会议？',
      okText: '重新预约',
      cancelText: '取消',
      onOk,
      centered: true,
      autoFocusButton: null,
      zIndex: 3000,
    });
  });
};

export const promptRebookOnExtendMeetingError = (error: any, onOk: () => void): boolean => {
  if (!isExtendMeetingRebookError(error)) return false;
  showExtendMeetingRebookConfirm(onOk);
  return true;
};

export const buildExtendMeetingRebookUrl = (baseUrl: string, meetingNo?: string) => {
  if (!meetingNo) return baseUrl;

  const connector = baseUrl.includes('?') ? '&' : '?';
  return `${baseUrl}${connector}${EXTEND_CONFLICT_MEETING_NO_QUERY}=${encodeURIComponent(meetingNo)}`;
};

export const buildRebookMeetingUrl = (baseUrl: string, meetingNo?: string) => {
  if (!meetingNo) return baseUrl;

  const connector = baseUrl.includes('?') ? '&' : '?';
  return `${baseUrl}${connector}${REBOOK_MEETING_NO_QUERY}=${encodeURIComponent(meetingNo)}`;
};
